import { useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';
import { scrollTop } from '@/helpers/utils';
import { Pagination } from '@/components/Pagination';
import { useGetCashMovementsList } from '@/query/queries/activity/useGetCashMovementsList';
import { Table } from './table';
import s from './index.module.scss';

export const DataView = ({ params, setParams }) => {
  const { type: accountType } = useOutletContext();
  const { data, isLoading } = useGetCashMovementsList({
    page: params.page,
    date_from: params.range[0],
    date_to: params.range[1],
    operation_types: params.operation_types,
    grouping: JSON.stringify(params.grouping),
    type: accountType,
  });

  useEffect(() => {
    scrollTop();
  }, [params.page]);

  return (
    <div className={s.wrapper}>
      <Table isLoading={isLoading} data={data} accountType={accountType} />
      {data?.total_pages > 0 && (
        <Pagination
          currentPage={params.page - 1}
          totalPages={data?.total_pages}
          onPageChange={({ selected }) => setParams(prev => ({ ...prev, page: selected + 1 }))}
        />
      )}
    </div>
  );
};
